"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STOREFRONT_METRICS = void 0;
exports.STOREFRONT_METRICS = {
    total_visitors: {
        label: 'Visitors',
        tooltip: {
            PAID: 'Unique visitors to the storefront',
            OWNED: 'Unique visitors to the storefront',
        },
        format: 'number',
    },
    total_clicks: {
        label: 'Clicks',
        tooltip: {
            PAID: 'Total number of clicks to the storefront',
            OWNED: 'Total number of clicks to the storefront',
        },
        format: 'number',
    },
    add_to_cart_rate: {
        label: 'Add to Cart Rate',
        tooltip: {
            PAID: 'Percentage of clicks that added to cart',
            OWNED: 'Percentage of visitors who added to cart',
        },
        format: 'percent',
    },
    total_purchases: {
        label: 'Purchases',
        tooltip: {
            PAID: 'Total number of purchases',
            OWNED: 'Total number of purchases',
        },
        format: 'number',
    },
    conversion_rate: {
        label: 'Conversion Rate',
        tooltip: {
            PAID: 'Percentage of clicks that resulted in a purchase',
            OWNED: 'Percentage of visitors who purchased',
        },
        format: 'percent',
    },
    total_purchases_value: {
        label: 'Revenue',
        tooltip: {
            PAID: 'Total revenue from purchases',
            OWNED: 'Total revenue from purchases',
        },
        format: 'currency',
    },
    average_order_value: {
        label: 'Average Order Value',
        tooltip: {
            PAID: 'Average order value',
            OWNED: 'Average order value',
        },
        format: 'currency',
    },
    value_per_click: {
        label: 'Revenue Per Click',
        tooltip: {
            PAID: 'Average revenue per click',
            OWNED: 'Average revenue per click',
        },
        format: 'currency',
    },
};
